import { Handle, Position } from '@xyflow/react'

const OPERATORS = ['==', '!=', '>', '<', '>=', '<=']

export function RuleCompareNode({ data, selected }) {
  const op        = data.operator  ?? '>'
  const threshold = data.threshold ?? 0

  return (
    <div style={{
      background: selected ? '#1e1e2a' : '#141420',
      border: `2px solid ${selected ? '#7070d0' : '#404080'}`,
      borderRadius: 6,
      padding: '8px 12px',
      minWidth: 140,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 11,
    }}>
      <div style={{ color: '#9090d0', fontWeight: 'bold', fontSize: 9, letterSpacing: 1, marginBottom: 6 }}>
        COMPARE
      </div>

      {/* Operator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5, position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="value"
          style={{ background: '#7070d0', width: 10, height: 10 }}
        />
        <span style={{ color: '#8080c0', fontSize: 10, marginLeft: 14 }}>value</span>
      </div>

      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <select
          value={op}
          onChange={e => data.onChange?.('operator', e.target.value)}
          onMouseDown={e => e.stopPropagation()}
          style={{
            background: '#111',
            color: '#b0b0ff',
            border: '1px solid #404080',
            borderRadius: 3,
            padding: '2px 4px',
            fontSize: 12,
            fontWeight: 'bold',
            cursor: 'pointer',
            flex: 1,
          }}
        >
          {OPERATORS.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
        <input
          type="text"
          value={threshold}
          onChange={e => {
            // Preserve type: numeric strings store as numbers, everything
            // else stores as string (e.g. "listening" / "talking" for
            // string variables like ConversationalState).
            const raw = e.target.value
            const isNum = raw.trim() !== '' && !isNaN(Number(raw)) && /^-?\d+(\.\d+)?$/.test(raw.trim())
            data.onChange?.('threshold', isNum ? Number(raw) : raw)
          }}
          onMouseDown={e => e.stopPropagation()}
          placeholder="value"
          style={{
            width: 90,
            background: '#111',
            color: '#b0b0ff',
            border: '1px solid #404080',
            borderRadius: 3,
            padding: '2px 4px',
            fontSize: 11,
            outline: 'none',
            fontFamily: 'var(--m-mono)',
          }}
        />
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="out"
        style={{ background: '#7070d0', width: 10, height: 10 }}
      />
    </div>
  )
}
